// Local engine activity is supplied only by supported desktop editions.
export default function useLocalWorkCreditActivity() { return false; }
